import createIcon from '../../createIcon';

/**
 * @component @name TouchApp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC43NSA5Ljc0VjZDOC43NSA0LjYyIDkuODcgMy41IDExLjI1IDMuNUMxMi42MyAzLjUgMTMuNzUgNC42MiAxMy43NSA2VjkuNzRDMTQuOTYgOC45MyAxNS43NSA3LjU2IDE1Ljc1IDZDMTUuNzUgMy41MSAxMy43NCAxLjUgMTEuMjUgMS41QzguNzYgMS41IDYuNzUgMy41MSA2Ljc1IDZDNi43NSA3LjU2IDcuNTQgOC45MyA4Ljc1IDkuNzRaTTE4LjU5IDE0LjM3TDE0LjA1IDEyLjExQzEzLjg4IDEyLjA0IDEzLjcgMTIgMTMuNTEgMTJIMTIuNzVWNkMxMi43NSA1LjE3IDEyLjA4IDQuNSAxMS4yNSA0LjVDMTAuNDIgNC41IDkuNzUgNS4xNyA5Ljc1IDZWMTYuNzRDNi4xNSAxNS45OCA2LjIxIDE1Ljk5IDYuMDggMTUuOTlDNS43NyAxNS45OSA1LjQ5IDE2LjEyIDUuMjkgMTYuMzJMNC41IDE3LjEyTDkuNDQgMjIuMDZDOS43MSAyMi4zMyAxMC4wOSAyMi41IDEwLjUgMjIuNUgxNy4yOUMxOC4wNCAyMi41IDE4LjYyIDIxLjk1IDE4LjczIDIxLjIyTDE5LjQ4IDE1Ljk1QzE5LjQ5IDE1Ljg4IDE5LjUgMTUuODEgMTkuNSAxNS43NUMxOS41IDE1LjEzIDE5LjEyIDE0LjU5IDE4LjU5IDE0LjM3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TouchApp = createIcon('TouchApp', [
  [
    'path',
    {
      d: 'M8.75 9.74V6C8.75 4.62 9.87 3.5 11.25 3.5C12.63 3.5 13.75 4.62 13.75 6V9.74C14.96 8.93 15.75 7.56 15.75 6C15.75 3.51 13.74 1.5 11.25 1.5C8.76 1.5 6.75 3.51 6.75 6C6.75 7.56 7.54 8.93 8.75 9.74ZM18.59 14.37L14.05 12.11C13.88 12.04 13.7 12 13.51 12H12.75V6C12.75 5.17 12.08 4.5 11.25 4.5C10.42 4.5 9.75 5.17 9.75 6V16.74C6.15 15.98 6.21 15.99 6.08 15.99C5.77 15.99 5.49 16.12 5.29 16.32L4.5 17.12L9.44 22.06C9.71 22.33 10.09 22.5 10.5 22.5H17.29C18.04 22.5 18.62 21.95 18.73 21.22L19.48 15.95C19.49 15.88 19.5 15.81 19.5 15.75C19.5 15.13 19.12 14.59 18.59 14.37Z',
      key: 'yvvapb',
    },
  ],
]);

export default TouchApp;
